import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDepartmentStoreinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 64 64",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		strokeLinejoin: "round",
		stroke: "currentColor",
		strokeWidth: 2,
		children: [
			/* @__PURE__ */ _jsx("path", {
				strokeLinecap: "square",
				d: "M5 16h54v43H5zm24 19a8 8 0 1 0-16 0"
			}),
			/* @__PURE__ */ _jsx("path", {
				strokeLinecap: "square",
				d: "M13 35h16v24H13zm36-5h1.25c-.208 1.615 0 2.423.625 2.423.938 0 3.125.404 3.125 2.423 0 2.02-1.875 3.492-1.875 6.462 0 2.97 1.563 4.038 1.563 6.865 0 1.885-.521 2.827-1.563 2.827h-6.25c-1.042 0-1.563-.942-1.563-2.827 0-2.827 1.563-3.896 1.563-6.865 0-2.97-1.875-4.443-1.875-6.462 0-2.02 2.188-2.423 3.125-2.423.625 0 .833-.808.625-2.423H49zm0 21v8M21 35v24M5 16V6h54v10"
			}),
			/* @__PURE__ */ _jsx("path", { d: "M37 16v43" }),
			/* @__PURE__ */ _jsx("path", {
				d: "M59 13v3a4 4 0 0 1-4 4h-4.125a3.995 3.995 0 0 1-3.242-1.657A3.995 3.995 0 0 1 44.391 20h-4.125a3.995 3.995 0 0 1-3.242-1.657A3.995 3.995 0 0 1 33.782 20h-4.125a3.995 3.995 0 0 1-3.242-1.657A3.995 3.995 0 0 1 23.173 20h-4.125a3.99 3.99 0 0 1-2.952-1.3 3.99 3.99 0 0 1-2.952 1.3H9.02a4 4 0 0 1-4-4V6H59v7z",
				strokeLinecap: "square"
			})
		]
	})
});
export default SvgDepartmentStoreinline;
